export default __webpack_public_path__ + "static/FeatureKlimtDesktop-40c68baecf5907a4d8a6382a99e3875f.png";